import EventTarget from "@ungap/event-target";
export let MediaBreakpoint = /*#__PURE__*/function (MediaBreakpoint) {
  MediaBreakpoint["xLarge"] = "xLarge";
  MediaBreakpoint["large"] = "large";
  MediaBreakpoint["medium"] = "medium";
  MediaBreakpoint["small"] = "small";
  MediaBreakpoint["xSmall"] = "xSmall";
  return MediaBreakpoint;
}({});
export const mediaBreakpointMinWidthMap = new Map([[MediaBreakpoint.xLarge, "1920px"], [MediaBreakpoint.large, "1600px"], [MediaBreakpoint.medium, "1280px"], [MediaBreakpoint.small, "1024px"], [MediaBreakpoint.xSmall, 0]]);
export const mediaEventTarget = new EventTarget();
const breakpointMatchesMap = {};
const MEDIA = {};
function handleMatchesChange(data, breakpoint) {
  let changed = false;
  breakpointMatchesMap[breakpoint] = data.matches;
  for (const [breakpoint] of mediaBreakpointMinWidthMap) {
    if (breakpointMatchesMap[breakpoint] && MEDIA.breakpoint !== breakpoint) {
      MEDIA.breakpoint = breakpoint;
      changed = true;
      break;
    }
  }
  if (changed) {
    mediaEventTarget.dispatchEvent(new CustomEvent("change", {
      detail: MEDIA
    }));
  }
}
mediaBreakpointMinWidthMap.forEach((minWidth, breakpoint) => {
  const mediaQueryList = window.matchMedia(`(min-width: ${minWidth})`);
  handleMatchesChange(mediaQueryList, breakpoint);
  if (mediaQueryList.addEventListener) {
    mediaQueryList.addEventListener("change", event => {
      handleMatchesChange(event, breakpoint);
    });
  } else {
    mediaQueryList.addListener(event => {
      handleMatchesChange(event, breakpoint);
    });
  }
});
export const getMedia = () => MEDIA;
//# sourceMappingURL=mediaQuery.js.map